import axiosClient from './axiosClient';
import { API_URLS } from '../constants/apiUrls';
import { IAddPaxOnFlight } from '../type/addNotOnFlight';

const passengerManifestApi = {
  getPassengerManifest: (date: string, ownerId: number) => {
    return axiosClient.get(
      `${API_URLS.PASSENGER_MANIFEST}?operationDate=${date}&ownerId=${ownerId}`,
    );
  },

  addNotOnFlight: (data: IAddPaxOnFlight) => {
    return axiosClient.post(`${API_URLS.ADD_NOT_ON_THIS_FLIGHT}`, data);
  },
};

export default passengerManifestApi;
